import { useState } from "react";

const faqs = [
  {
    q: "야간이나 주말에도 출동이 가능한가요?",
    a: "네, 365일 24시간 연중무휴로 운영됩니다. 야간, 공휴일, 명절 등 언제든지 연락 주시면 즉시 출동합니다.",
  },
  {
    q: "누수 원인을 어떻게 찾나요?",
    a: "현장확인후 매립배관으로 판단되면 비파괴 가스탐지기와 청음기, 열화상 카메라를 사용해 벽이나 바닥을 손상하지 않고 최대한 정확한 누수 위치를 찾아낸 후 공사를 진행합니다.",
  },
  {
    q: "아파트 층간 누수는 어떻게 처리하나요?",
    a: "비파괴 탐지로 정확한 위치를 확인한 후, 최소한의 개구부로 보수합니다. 위층 아래층 모두 조율하여 진행하며 마무리까지 깔끔하게 처리합니다.",
  },
  {
    q: "시공 후 AS는 어떻게 되나요?",
    a: "시공 완료 후 보증서를 제공하며, 동일 부위에서 재발 시 무상으로 재보수해드립니다. 고객 만족이 최우선입니다.",
  },
  {
    q: "서울 경기 외 지역도 출동이 가능한가요?",
    a: "기본적으로 서울·경기·인천 수도권 전지역을 커버합니다. 그 외 지역은 전화 상담 시 출동 가능 여부를 확인해드립니다.",
  },
  {
    q: "견적을 미리 받을 수 있나요?",
    a: "현장 탐지 전 정확한 견적은 어렵지만, 전화 상담을 통해 대략적인 비용 범위와 작업 내용을 미리 안내해드릴 수 있습니다.",
  },
  {
    q: "보험으로 처리가 가능한가요?",
    a: "누수 원인과 상황에 따라 화재보험(풍수해보험)으로 처리가 가능한 경우가 있습니다. 시공 전 상담 시 보험 적용 여부를 함께 검토해드립니다.",
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section id="faq" className="py-14 lg:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-10 lg:mb-14">
          <span className="inline-block text-blue-500 font-bold text-xs lg:text-sm tracking-widest uppercase mb-2 lg:mb-3">FAQ</span>
          <h2 className="text-2xl lg:text-4xl font-black text-zinc-900 mb-3 lg:mb-4">자주 묻는 질문</h2>
          <p className="text-zinc-500 text-sm lg:text-lg">궁금한 점이 있으시면 언제든지 전화 주세요!</p>
        </div>

        <div className="flex flex-col gap-3 lg:gap-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className={`border rounded-xl overflow-hidden transition-all duration-200 ${
                openIdx === idx ? "border-blue-300" : "border-zinc-200"
              }`}
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-4 lg:px-6 py-4 lg:py-5 text-left cursor-pointer bg-white hover:bg-blue-50 transition-colors"
              >
                <span className="text-zinc-800 text-sm lg:text-base font-semibold pr-3 lg:pr-4">{faq.q}</span>
                <span className={`w-5 h-5 lg:w-6 lg:h-6 flex items-center justify-center text-blue-500 transition-transform duration-300 flex-shrink-0 ${openIdx === idx ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-lg lg:text-xl" />
                </span>
              </button>
              {openIdx === idx && (
                <div className="px-4 lg:px-6 pb-4 lg:pb-5 bg-blue-50 border-t border-blue-100">
                  <p className="text-zinc-600 text-xs lg:text-sm leading-relaxed pt-3 lg:pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 lg:mt-12 text-center">
          <p className="text-zinc-500 text-sm lg:text-base mb-3 lg:mb-4">더 궁금한 점이 있으신가요?</p>
          <a
            href="tel:010-2684-4892"
            className="inline-flex items-center gap-2 bg-blue-500 hover:bg-blue-400 text-white font-bold text-sm lg:text-base px-5 lg:px-7 py-3 lg:py-3.5 rounded-full transition-all cursor-pointer whitespace-nowrap"
          >
            <span className="w-4 h-4 lg:w-5 lg:h-5 flex items-center justify-center">
              <i className="ri-phone-fill" />
            </span>
            010-2684-4892 지금 전화 상담
          </a>
        </div>
      </div>
    </section>
  );
}
